import { ArrowUp } from '@teamsparta/stack-icons';
import { vars } from '@teamsparta/stack-tokens';
import React, { useRef } from 'react';

import type { WebinarDto, WebinarPreviewDto } from '@/api/webinar';
import CourseBanner from '@/pages/webinar/[title]/components/CourseBanner';
import SectionTitleBar from '@/pages/webinar/[title]/components/SectionTitleBar';
import WebinarInfoSection from '@/pages/webinar/[title]/components/WebinarInfoSection';
import WebinarLecturerSection from '@/pages/webinar/[title]/components/WebinarLecturerSection';
import WebinarRecommend from '@/pages/webinar/[title]/components/WebinarRecommend';
import WebinarTopicSection from '@/pages/webinar/[title]/components/WebinarTopicSection';
import WebinarVideoSection from '@/pages/webinar/[title]/components/WebinarVideoSection';

import * as S from './style';

type WebinarDetailPageTemplateProps = {
  webinar: WebinarDto;
  recommends: WebinarPreviewDto[];
  onlineUserId: string;
};
const Template = ({
  webinar,
  recommends,
  onlineUserId,
}: WebinarDetailPageTemplateProps) => {
  const refs = useRef([
    React.createRef<HTMLElement>(),
    React.createRef<HTMLElement>(),
    React.createRef<HTMLElement>(),
  ]);

  return (
    <S.Container>
      <S.Content>
        <S.WebinarContainer>
          <WebinarVideoSection webinar={webinar} onlineUserId={onlineUserId} />
          <SectionTitleBar refs={refs} />
          <S.Wrapper>
            <WebinarInfoSection
              refObject={refs.current[0]}
              info={webinar.info}
            />
            <S.Divider />
            <WebinarLecturerSection
              refObject={refs.current[1]}
              lecturer={webinar.lecturer}
            />
            <S.Divider />
            <WebinarTopicSection
              refObject={refs.current[2]}
              topics={webinar.topics}
            />
          </S.Wrapper>
          <S.MoveToTop
            className='desktop'
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <ArrowUp size={20} color={vars.neutral[70]} /> 맨 위로 이동
          </S.MoveToTop>
        </S.WebinarContainer>
        {webinar.status === 'done' && (
          <S.Aside>
            <WebinarRecommend recommends={recommends} />
            <CourseBanner
              className='desktop'
              course={webinar.metadata.course}
            />
          </S.Aside>
        )}
      </S.Content>
      <S.MoveToTop
        className='mobile'
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <ArrowUp size={20} color={vars.neutral[70]} /> 맨 위로 이동
      </S.MoveToTop>
    </S.Container>
  );
};
export default Template;
